<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-form v-model="valid">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field label="Name" variant="outlined" v-model="name" ></v-text-field>
                                </v-col>
                                <v-col cols="0" sm="0" md="0" lg="6" xl="8"></v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn variant="elevated" class="ml-2 mr-3"
                                @click="$router.push('/locations')">Back</v-btn>
                            <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>


<script>

import LocationApi from '../services/LocationApi'

export default {
    name: 'LocationEdit',
    data() {
        return {
            id: '',
            valid: false,
            name: "",
            title: '',
            snackbar: false,
            message: "",
            timeout: 2000
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        
        if (!isNaN(this.id)) {
            this.title = "Edit";
            LocationApi.get(this.id).then((response) => {
                if (response && response.data) {
                    this.name = response.data.name;
                }
            })
        }
        else {
            this.title = "Create";
        }
    },
    methods: {
         save() {
            if(!isNaN(this.id)) {
                var payload = {
                    locationId: this.id,
                    name: this.name
                };
                LocationApi.put(this.id, payload).then((response) => {
                    if (response && response.data) {
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                }).catch((e) => {
                    this.message = e.message;
                    this.snackbar = true;
                })
            }
            else {
                var body = {
                    name: this.name
                };
                LocationApi.post(body).then((response) => {
                    if (response && response.data) {
                        this.code = response.data.code;
                        this.id = response.data.locationId;
                        this.$router.push(`/locations/${this.id}`);

                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                }).catch((e) => {
                    this.message = e.message;
                    this.snackbar = true;
                })
            }
        }
    }
}
</script>